{
  "INBOX_MGMT": {
    "HEADER": "Safates d'entrada",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Torna a connectar",
      "FACEBOOK": "La connexió amb Facebook ha caducat o s'ha revocat. Els missatges enviats a la pàgina no arriben a aquesta safata d'entrada i les respostes poden fallar. Una persona que gestioni la pàgina de Facebook ha de fer clic a Torna a connectar i iniciar la sessió a Facebook.",
      "INSTAGRAM": "La connexió amb Instagram ha caducat o s'ha revocat. Els missatges enviats al compte no arriben a aquesta safata d'entrada i les respostes poden fallar. Fes clic a Torna a connectar i inicia la sessió amb el mateix compte d'Instagram. Un altre compte crea una safata d'entrada nova.",
      "GOOGLE": "La connexió amb Google ha caducat o s'ha revocat. Els correus nous no arriben a aquesta safata d'entrada i les respostes poden fallar. Fes clic a Torna a connectar i inicia la sessió a Google com a {email}.",
      "MICROSOFT": "La connexió amb Microsoft ha caducat o s'ha revocat. Els correus nous no arriben a aquesta safata d'entrada i les respostes poden fallar. Fes clic a Torna a connectar i inicia la sessió a Microsoft com a {email}.",
      "ALLEGRO": "La connexió amb Allegro ha caducat o s'ha revocat. Els missatges dels compradors no arriben a aquesta safata d'entrada i les respostes poden fallar. Fes clic a Torna a connectar i inicia la sessió a Allegro com el venedor {seller}. Un altre compte de venedor crea una safata d'entrada nova.",
      "IMAP_LOGIN": "El servidor de correu rebutja l'inici de sessió d'IMAP com a {login}. Els correus nous no arriben a aquesta safata. Comprova l'usuari i la contrasenya d'IMAP a la pestanya {tab} i desa'ls. Continuem intentant iniciar la sessió i la safata es recuperarà tan bon punt l'inici de sessió funcioni.",
      "WHATSAPP": "La connexió amb WhatsApp ha caducat o s'ha revocat. Els fitxers adjunts dels clients no arriben a aquesta safata d'entrada i les respostes poden fallar. Feu clic a Torna a connectar, inicieu la sessió a Facebook i torneu a seleccionar el número {phone}."
    },
    "LIST": {
      "404": "No hi ha cap safata d'entrada connectat a aquest compte.",
      "RECONNECT_REQUIRED": "Cal tornar a connectar"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Triar canal",
        "BODY": "Trieu el proveïdor que vulgueu integrar amb el xat."
      },
      "INBOX": {
        "TITLE": "Crear safata d'entrada",
        "BODY": "Autentiqueu el vostre compte i creeu una safata d'entrada."
      },
      "AGENT": {
        "TITLE": "Afegir agents",
        "BODY": "Afegir agents a la safata d'entrada creada."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Ja estàs preparat!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nom de la safata d'entrada",
        "PLACEHOLDER": "Introdueix el nom de la safata d'entrada (p. ex.: Acme Inc)",
        "ERROR": "Introdueix un nom de safata d'entrada vàlid"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nom del lloc web",
        "PLACEHOLDER": "Introdueix el nom del vostre lloc web (per exemple: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Nom intern",
        "PLACEHOLDER": "Anomena la safata d'entrada tal com apareixerà en aquest tauler",
        "ERROR": "Introdueix un nom intern únic"
      },
      "FB": {
        "HELP": "PD: En iniciar la sessió, només accedim als missatges de la vostra pàgina. Mai no podrem accedir als vostres missatges privats.",
        "CHOOSE_PAGE": "Trieu la pàgina",
        "CHOOSE_PLACEHOLDER": "Selecciona una pàgina de la llista",
        "INBOX_NAME": "Nom de la safata d'entrada",
        "ADD_NAME": "Afegeix un nom per a la safata d'entrada",
        "PICK_NAME": "Tria un nom per a la teva safata d'entrada",
        "PICK_A_VALUE": "Tria un valor",
        "CREATE_INBOX": "Crea la safata d'entrada"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continua amb Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connecta el teu perfil d'Instagram",
        "HELP": "Per afegir el teu perfil d'Instagram com a canal, has d'autenticar-lo fent clic a \"Continua amb Instagram\" ",
        "ERROR_MESSAGE": "S'ha produït un error en connectar amb Instagram, torna-ho a provar",
        "ERROR_AUTH": "S'ha produït un error en connectar amb Instagram, torna-ho a provar",
        "NEW_INBOX_SUGGESTION": "Aquest compte d'Instagram estava vinculat anteriorment a una altra safata d'entrada i ara s'ha migrat aquí. Tots els missatges nous apareixeran aquí. La safata d'entrada antiga ja no podrà enviar ni rebre missatges d'aquest compte.",
        "DUPLICATE_INBOX_BANNER": "Aquest compte d'Instagram s'ha migrat a la nova safata d'entrada del canal d'Instagram. Ja no podràs enviar ni rebre missatges d'Instagram des d'aquesta safata d'entrada."
      },
      "TWITTER": {
        "HELP": "Per afegir el teu perfil de Twitter com a canal, has d'autentificar el vostre perfil de Twitter fent clic a 'Inicieu la sessió amb Twitter' ",
        "ERROR_MESSAGE": "S'ha produït un error en connectar amb Twitter, torna-ho a provar",
        "TWEETS": {
          "ENABLE": "Crea converses a partir dels tuits esmentats"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal Web",
        "DESC": "Crea un canal per al vostre lloc web i comença a donar suport als vostres clients mitjançant el teu widget del lloc web.",
        "LOADING_MESSAGE": "S'està creant el canal de suport web",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar del canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL del webhook",
          "PLACEHOLDER": "Introdueix l'URL del teu webhook",
          "ERROR": "Introduïu una URL vàlid"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domini del lloc web",
          "PLACEHOLDER": "Introduïu el vostre domini de lloc web (pe: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Encapçalament de benvinguda",
          "PLACEHOLDER": "Hola!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Lema de benvinguda",
          "PLACEHOLDER": "Facilitem la connexió amb nosaltres. Pregunteu-nos qualsevol cosa o compartiu els vostres comentaris."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Missatge de felicitació del canal",
          "PLACEHOLDER": "Acme Inc sol respondre en poques hores."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Activa la salutació del canal",
          "HELP_TEXT": "Envia automàticament missatges de salutació quan els clients inicien una conversa i envien el seu primer missatge.",
          "ENABLED": "Habilita",
          "DISABLED": "Inhabilita"
        },
        "REPLY_TIME": {
          "TITLE": "Estableix el temps de resposta",
          "IN_A_FEW_MINUTES": "En pocs minuts",
          "IN_A_FEW_HOURS": "En poques hores",
          "IN_A_DAY": "En un dia",
          "HELP_TEXT": "Aquest temps de resposta es mostrarà al widget de xat en directe"
        },
        "WIDGET_COLOR": {
          "LABEL": "Color del Widget",
          "PLACEHOLDER": "Actualitza el color del widget"
        },
        "SUBMIT_BUTTON": "Crea la safata entrada",
        "API": {
          "ERROR_MESSAGE": "No hem pogut crear un canal de lloc web, torna-ho a provar"
        }
      },
      "TWILIO": {
        "TITLE": "Canal Twilio SMS/WhatsApp",
        "DESC": "Integra Twilio i comença a donar suport als teus clients mitjançant SMS o WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Compte SID",
          "PLACEHOLDER": "Introduïu el vostre compte Twilio SID",
          "ERROR": "Aquest camp és obligatori"
        },
        "API_KEY": {
          "USE_API_KEY": "Utilitzeu l'autenticació API Key",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Introdueix la teva API Key SID",
          "ERROR": "Aquest camp és obligatori"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Introdueix la teva API Key Secret",
          "ERROR": "Aquest camp és obligatori"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID del servei de missatgeria",
          "PLACEHOLDER": "Introdueix el teu SID del servei de missatgeria Twilio",
          "ERROR": "Aquest camp és obligatori",
          "USE_MESSAGING_SERVICE": "Utilitza un servei de missatgeria Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipus de canal",
          "ERROR": "Seleccioneu el teu tipus de canal"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token d'autenticació",
          "PLACEHOLDER": "Introduïu el vostre Twilio Auth Token",
          "ERROR": "Aquest camp és obligatori"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nom de la safata d'entrada",
          "PLACEHOLDER": "Introdueix un nom de safata d'entrada",
          "ERROR": "Aquest camp és obligatori"
        },
        "PHONE_NUMBER": {
          "LABEL": "Número de telèfon",
          "PLACEHOLDER": "Introduïu el número de telèfon des del qual serà enviat el missatge.",
          "ERROR": "Proporciona un número de telèfon vàlid que comenci amb un signe \"+\" i que no contingui espais."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Has de configurar l'URL de callback a Twilio amb l'URL que s'esmenta aquí."
        },
        "SUBMIT_BUTTON": "Crear un canal Twilio",
        "API": {
          "ERROR_MESSAGE": "No hem pogut autenticar les credencials de Twilio, prova de nou"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Comença a donar suport als teus clients mitjançant SMS.",
        "PROVIDERS": {
          "LABEL": "Proveïdor d'API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID del compte",
            "PLACEHOLDER": "Introdueix l'identificador del teu compte de Bandwidth",
            "ERROR": "Aquest camp és obligatori"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Introdueix la teva API Key de Bandwidth",
            "ERROR": "Aquest camp és obligatori"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Introdueix la teva API Secret de Bandwidth",
            "ERROR": "Aquest camp és obligatori"
          },
          "APPLICATION_ID": {
            "LABEL": "ID d'aplicació",
            "PLACEHOLDER": "Introdueix el teu ID de l'aplicació Bandwidth",
            "ERROR": "Aquest camp és obligatori"
          },
          "INBOX_NAME": {
            "LABEL": "Nom de la safata d'entrada",
            "PLACEHOLDER": "Introdueix un nom de safata d'entrada",
            "ERROR": "Aquest camp és obligatori"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de telèfon",
            "PLACEHOLDER": "Introduïu el número de telèfon des del qual serà enviat el missatge.",
            "ERROR": "Proporciona un número de telèfon vàlid que comenci amb un signe \"+\" i que no contingui espais."
          },
          "SUBMIT_BUTTON": "Crea un canal de Bandwidth",
          "API": {
            "ERROR_MESSAGE": "No hem pogut autenticar les credencials de Bandwidth, prova de nou"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Has de configurar l'URL de devolució del missatge a Bandwidth amb l'URL esmentada aquí."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nom de la safata d'entrada",
            "PLACEHOLDER": "Introdueix un nom per a la safata d'entrada",
            "ERROR": "Aquest camp és obligatori"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de telèfon",
            "PLACEHOLDER": "Introdueix el número de telèfon des del qual s'enviaran els missatges.",
            "ERROR": "Introdueix un número de telèfon vàlid que comenci amb un signe `+`."
          },
          "SUBMIT_BUTTON": "Crea el canal SMS Brana",
          "API": {
            "ERROR_MESSAGE": "No s'ha pogut crear el canal SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nom de la safata d'entrada",
            "PLACEHOLDER": "Introdueix un nom per a la safata d'entrada",
            "ERROR": "Aquest camp és obligatori"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de telèfon",
            "PLACEHOLDER": "Introdueix el número de telèfon des del qual s'enviaran els missatges.",
            "ERROR": "Introdueix un número de telèfon vàlid que comenci amb un signe `+`."
          },
          "SUBMIT_BUTTON": "Crea el canal DIDWW",
          "API": {
            "ERROR_MESSAGE": "No s'ha pogut crear el canal DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Proveïdor d'API",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Has de configurar l'URL del webhook i el testimoni de verificació al portal de desenvolupadors de Facebook amb els valors que es mostren a continuació.",
          "WEBHOOK_URL": "URL del webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Token de verificació del webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Configuració ràpida amb Meta",
          "DESC": "Se't redirigirà a Meta perquè iniciïs sessió al teu compte de WhatsApp Business. Tenir accés d'administrador facilitarà que la configuració sigui ràpida i senzilla.",
          "BENEFITS": {
            "EASY_SETUP": "No cal cap configuració manual",
            "SECURE_AUTH": "Autenticació segura basada en OAuth",
            "AUTO_CONFIG": "Configuració automàtica del webhook i del número de telèfon"
          },
          "SUBMIT_BUTTON": "Connecta amb WhatsApp Business",
          "AUTH_PROCESSING": "S'està autenticant amb Meta",
          "WAITING_FOR_BUSINESS_INFO": "Completa la configuració del negoci a la finestra de Meta...",
          "PROCESSING": "S'està configurant el teu compte de WhatsApp Business",
          "CANCELLED": "S'ha cancel·lat el registre de WhatsApp",
          "WAITING_FOR_AUTH": "S'està esperant l'autenticació...",
          "INVALID_BUSINESS_DATA": "S'han rebut dades de negoci no vàlides des de Facebook. Torna-ho a provar.",
          "SIGNUP_ERROR": "S'ha produït un error en el registre",
          "SDK_LOAD_ERROR": "No s'ha pogut carregar l'SDK de Facebook. Torneu-ho a provar.",
          "AUTH_NOT_COMPLETED": "L'autenticació no s'ha completat. Torna a iniciar el procés.",
          "SUCCESS_FALLBACK": "El compte de WhatsApp Business s'ha configurat correctament",
          "RECONNECTED": "El canal de WhatsApp s'ha tornat a connectar correctament"
        },
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal de l'API",
        "DESC": "Integra’t amb el canal API i comença a donar suport als teus clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom del canal",
          "PLACEHOLDER": "Introduïu el nom del canal",
          "ERROR": "Aquest camp és obligatori"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL del webhook",
          "SUBTITLE": "Configura l'URL on vulguis rebre les devolucions de trucada dels esdeveniments.",
          "PLACEHOLDER": "URL del webhook"
        },
        "SUBMIT_BUTTON": "Crea un canal API",
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal API"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Canal de Salesforce",
        "DESC": "Integra't amb el canal de Salesforce i comença a donar suport als teus clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom del canal",
          "PLACEHOLDER": "Introdueix un nom de canal",
          "ERROR": "Aquest camp és obligatori"
        },
        "API_BASE_URL": {
          "LABEL": "URL de l'API de Salesforce",
          "SUBTITLE": "Configura l'URL base per a la teva instància de Salesforce.",
          "PLACEHOLDER": "URL de l'API de Salesforce"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID per al teu canal de Salesforce.",
          "PLACEHOLDER": "KEY ID"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret per al teu canal de Salesforce.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Crea el canal de Salesforce",
        "API": {
          "ERROR_MESSAGE": "No s'ha pogut desar el canal de Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL del webhook",
          "SUBTITLE": "Has de configurar l'URL del webhook a Salesforce amb l'URL indicada aquí."
        },
        "BEARER_TOKEN": {
          "TITLE": "Token Bearer",
          "SUBTITLE": "Utilitza aquest token Bearer per autenticar-te en configurar el webhook a Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Sobreescriu el remitent del correu",
          "SUBTITLE": "Si es configura, aquesta adreça de correu s'utilitzarà com a remitent per a tots els correus sortints en lloc del correu d'origen de la conversa.",
          "PLACEHOLDER": "p. ex. suport{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Canal d'Allegro",
        "DESC": "Connecta un compte de venedor d'Allegro i respon els seus missatges des del centre de contacte.",
        "CHANNEL_NAME": {
          "LABEL": "Nom de la safata d'entrada",
          "SUBTITLE": "El nom que els agents veuen per a aquesta safata d'entrada.",
          "PLACEHOLDER": "Introdueix un nom de safata d'entrada",
          "ERROR": "Aquest camp és obligatori"
        },
        "SUBMIT_BUTTON": "Inicia la sessió amb Allegro",
        "API": {
          "ERROR_MESSAGE": "Hi ha hagut un error en connectar amb Allegro, torna-ho a provar"
        },
        "SELLER_LOGIN": {
          "TITLE": "Inici de sessió d'Allegro",
          "SUBTITLE": "El compte de venedor del qual aquesta safata d'entrada llegeix i respon els missatges."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Canal de Kaufland",
        "DESC": "Respon els missatges de tiquets que els compradors t'envien al marketplace de Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nom del canal",
          "PLACEHOLDER": "Introdueix un nom de canal",
          "ERROR": "Aquest camp és obligatori"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "La Client Key (clau de client) de 32 caràcters de la pàgina de configuració de l'API del teu compte de venedor de Kaufland.",
          "PLACEHOLDER": "Clau de 32 caràcters",
          "ERROR": "Introdueix la Client Key de 32 caràcters"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "La Secret Key (clau secreta) de 64 caràcters que pertany a la Client Key. Kaufland la mostra una sola vegada i mai no la torna a enviar a aquesta pàgina.",
          "PLACEHOLDER": "Clau de 64 caràcters",
          "ERROR": "Introdueix la Secret Key de 64 caràcters"
        },
        "SUBMIT_BUTTON": "Crea un canal de Kaufland",
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal de Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Desconnectat",
          "MESSAGE": "Kaufland ha rebutjat aquestes claus d'API. Torna a introduir la client key i la secret key per tornar a connectar aquesta safata d'entrada."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Correu electrònic del Canal",
        "DESC": "Integra la teva safata d’entrada de correu electrònic.",
        "CHANNEL_NAME": {
          "LABEL": "Nom del canal",
          "PLACEHOLDER": "Introduïu el nom del canal",
          "ERROR": "Aquest camp és obligatori"
        },
        "EMAIL": {
          "LABEL": "Correu electrònic",
          "SUBTITLE": "Correu electrònic on els vostres clients us envien tickets de support",
          "PLACEHOLDER": "Correu electrònic"
        },
        "SUBMIT_BUTTON": "Crea un correu electrònic del Canal",
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal de correu electrònic"
        },
        "FINISH_MESSAGE": "Comença a reenviar els teus correus electrònics a la següent adreça electrònica."
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LINE",
        "DESC": "Integra't amb el canal LINE i comença a donar suport als teus clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom del canal",
          "PLACEHOLDER": "Introduïu el nom del canal",
          "ERROR": "Aquest camp és obligatori"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID del canal LINE",
          "PLACEHOLDER": "ID del canal LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret del canal LINE",
          "PLACEHOLDER": "Secret del canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token del canal LINE",
          "PLACEHOLDER": "Token del canal LINE"
        },
        "SUBMIT_BUTTON": "Crea un canal LINE",
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal de LINE"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Has de configurar l'URL del webhook a l'aplicació LINE amb l'URL esmentat aquí."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal de Telegram",
        "DESC": "Integra't amb el canal de Telegram i comença a donar suport als teus clients.",
        "BOT_TOKEN": {
          "LABEL": "Token del Bot",
          "SUBTITLE": "Configura el token del bot que has obtingut de Telegram BotFather.",
          "PLACEHOLDER": "Token del Bot"
        },
        "SUBMIT_BUTTON": "Crea el canal de Telegram",
        "API": {
          "ERROR_MESSAGE": "No hem pogut desar el canal de Telegram"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Trucades telefòniques",
        "DESC": "Configura quines trucades telefòniques es mostraran en aquesta safata d'entrada.",
        "NAME": {
          "LABEL": "Nom de la safata d'entrada",
          "SUBTITLE": "Tria un nom fàcil d'identificar."
        },
        "PHONE_NUMBER": {
          "LABEL": "Número de telèfon",
          "SUBTITLE": "Introdueix els números de telèfon que pertanyen a aquesta safata d'entrada; en pots afegir més més endavant.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Crea la safata d'entrada de trucades",
        "API": {
          "ERROR_MESSAGE": "No s'ha pogut crear la safata d'entrada"
        }
      },
      "AUTH": {
        "TITLE": "Escull un canal",
        "DESC": "El xat admet widgets de xat en directe, Facebook Messenger, WhatsApp, correus electrònics, etc., com a canals. Si voleu crear un canal personalitzat, podeu crear-lo mitjançant el canal API. Per començar, tria un dels canals següents."
      },
      "AGENTS": {
        "TITLE": "Agents",
        "DESC": "Aquí podeu afegir agents per gestionar la vostra safata d'entrada de nova creació. Només aquests agents seleccionats tindran accés a la vostra safata d'entrada. Els agents que no formen part d'aquesta safata d'entrada no podran veure ni respondre als missatges d'aquesta safata d'entrada quan s’inicien. <br><b>PD:</b> Com a administrador, si necessiteu accés a totes les bústies d’entrada, heu d’afegir-vos com a agent a totes les bústies de sortida que creeu.",
        "VALIDATION_ERROR": "Afegeix almenys un agent a la teva safata d'entrada",
        "PICK_AGENTS": "Tria agents per la safata d'entrada"
      },
      "DETAILS": {
        "TITLE": "Detalls de la safata d'entrada",
        "DESC": "Des del següent menú desplegable, seleccioneu la pàgina de Facebook que voleu connectar al xat. També podeu donar un nom personalitzat a la safata d'entrada per a una millor identificació."
      },
      "FINISH": {
        "TITLE": "L'has clavat!",
        "DESC": "Heu acabat d'integrar la vostra pàgina de Facebook amb el xat. La propera vegada que un client escrigui un missatge a la vostra pàgina, la conversa apareixerà automàticament a la safata d'entrada. <br>També us proporcionem un script del widget que podeu afegir fàcilment al vostre web. Una vegada que estigui operatiu al vostre web, els clients us podran enviar missatges des del web sense l’ajuda de cap eina externa i la conversa apareixerà aquí mateix, al xat. <br>Genial, eh? Bé, segur que intentem ser-ho :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Selecciona el teu proveïdor de correu electrònic",
        "DESCRIPTION": "Selecciona un proveïdor de correu electrònic de la següent llista. Si no veus el teu proveïdor de correu electrònic a la llista, pots seleccionar l'opció de l'altre proveïdor i proporcionar les credencials IMAP i SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Correu Microsoft",
        "DESCRIPTION": "Fes clic al botó Inicia sessió amb Microsoft per començar. Se't redirigirà a la pàgina d'inici de sessió del correu electrònic. Un cop acceptis els permisos sol·licitats, se't redirigirà al pas de creació de la safata d'entrada.",
        "EMAIL_PLACEHOLDER": "Introdueix una adreça de correu electrònic",
        "SIGN_IN": "Inicia la sessió amb Microsoft",
        "ERROR_MESSAGE": "S'ha produït un error en connectar amb Microsoft, torna-ho a provar"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Introdueix una adreça de correu electrònic",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "S'està autenticant amb Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Alguna cosa ha anat malament, actualitza la pàgina...",
      "ERROR_FB_UNAUTHORIZED": "No estàs autoritzat per dur a terme aquesta acció. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Assegura't que tens accés a la pàgina de Facebook amb control total. Pots obtenir més informació sobre les funcions de Facebook <a href=\" https://www.facebook.com/help/187316341316631\">aquí</a>.",
      "ERROR_CHANNEL_CREATION": "No hem pogut crear la safata d'entrada. Torna-ho a provar.",
      "CREATING_CHANNEL": "S'està creant la safata d'entrada...",
      "TITLE": "Configura els detalls de la safata d'entrada",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Afegir agents",
      "ADD_AGENTS": "S'estan afegint agents a la vostre safata d'entrada..."
    },
    "FINISH": {
      "TITLE": "La vostra safata d'entrada està a punt!",
      "MESSAGE": "Ja podeu interactuar amb els vostres clients a través del vostre canal nou. Feliç suport",
      "BUTTON_TEXT": "Porta'm allà",
      "MORE_SETTINGS": "Més configuracions",
      "WEBSITE_SUCCESS": "Heu finalitzat amb èxit la creació d'un canal web. Copieu el codi que es mostra a continuació i enganxeu-lo al lloc web. La propera vegada que un client utilitzi el xat en directe, la conversa apareixerà automàticament a la safata d'entrada."
    },
    "REAUTH": "Reautoritza",
    "VIEW": "Veure",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "El color del widget s'ha actualitzat correctament",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Assignació automàtica actualitzada correctament",
        "ERROR_MESSAGE": "No hem pogut actualitzar la configuració de la safata d'entrada. Intenta-ho més tard."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Habilitat",
        "DISABLED": "Inhabilitat"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Nom del remitent",
        "SUB_TEXT": "Selecciona el nom que es mostra al vostre client quan reben correus electrònics dels teus agents.",
        "FOR_EG": "Per exemple:",
        "FRIENDLY": {
          "TITLE": "Amable",
          "FROM": "des de",
          "SUBTITLE": "Afegeix el nom de l'agent que ha enviat la resposta al nom del remitent perquè sigui amigable."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Utilitza només el nom de l'empresa configurat com a nom del remitent a la capçalera del correu electrònic."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configura el nom del teu negoci",
          "PLACEHOLDER": "Introdueix el nom de la teva empresa",
          "SAVE_BUTTON_TEXT": "Desar"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Cap"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "ENABLE_HMAC": {
        "LABEL": "Habilita"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Habilita",
        "DISABLED": "Inhabilita"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Habilita la sincronització de correus entrants"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Habilita el domini de correu personalitzat (servei de pagament)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Habilita el processament de comentaris de Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Signatura HTML",
        "SUB_TEXT": "Aquesta signatura s'afegirà al peu de cada missatge enviat des d'aquesta safata d'entrada.",
        "HTML_CONTENT": "Codi HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} es substituirà pel nom de l'agent.\n{'{{'}email{'}}'} es substituirà per l'adreça de correu electrònic de l'agent que ha enviat el correu.\n{'{{'}position{'}}'} es substituirà pel càrrec de l'agent.\n{'{{'}custom_line{'}}'} es substituirà per la línia personalitzada de l'agent.\n{'{{'}email_signature_picture{'}}'} es substituirà per l'URL de la imatge de signatura de correu de l'agent (no una etiqueta d'imatge); utilitza-la com a font de la imatge (l'atribut src d'una etiqueta img).",
        "PREVIEW": "Vista prèvia"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signatures per país",
        "SUB_TEXT": "Una resposta rep la signatura del país del comprador.",
        "HELP": "Una resposta se signa segons el país de la seva conversa: la botiga de Kaufland, el mercat de la comanda d'Allegro o, si no, l'idioma en què escriu el comprador. Quan el país és desconegut o no té cap signatura aquí, s'utilitza la signatura HTML de dalt. Els mercats prohibeixen els enllaços al teu web i les dades de contacte, així que deixa només una salutació i {'{{'}name{'}}'}.",
        "EMPTY": "Encara no tens cap signatura per país, així que les respostes utilitzen la signatura HTML de dalt.",
        "COUNTRY": "Selecciona un país",
        "ADD": "Afegeix una signatura per país",
        "REMOVE": "Elimina"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefix de marcatge del número de telèfon",
        "PLACEHOLDER": "Introdueix el prefix per encaminar correctament les trucades (p. ex., *99)",
        "HELP_TEXT": "Aquest prefix s'anteposarà automàticament als números de telèfon dels contactes en marcar des d'aquesta safata d'entrada."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Text del botó «Resoldrem més tard»",
        "PLACEHOLDER": "p. ex. Resoldrem aquest tema per correu electrònic. Ara vull preguntar sobre una altra cosa.",
        "HELP_TEXT": "Text del botó del widget amb què el visitant deixa el tema actual i pregunta sobre una altra cosa. Si deixeu el camp buit, s'utilitzarà el text per defecte en l'idioma del visitant."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Posposa automàticament les trucades perdudes durant X minuts",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Posposa automàticament les trucades perdudes durant el nombre de minuts indicat. Deixa-ho buit o posa 0 per desactivar-ho."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Resol una trucada perduda després de X devolucions de trucada fallides",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Quan una trucada perduda s'ha tornat a trucar X vegades sense que el client respongui, es resol automàticament i s'hi afegeix una nota privada. Deixa-ho buit o posa 0 per desactivar-ho."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Suggeriments de preguntes",
        "SUB_TEXT": "Configura preguntes predefinides que els clients poden utilitzar per interactuar amb els teus agents.",
        "QUESTIONS_LABEL": "Preguntes",
        "ADD_QUESTION": "Afegeix una pregunta",
        "REMOVE": "Elimina",
        "QUESTION_TEXT": "Text que es mostra a la bombolla.",
        "QUESTION_TEXT_PLACEHOLDER": "Obligatori",
        "QUESTION_PAYLOAD": "Text que s'envia en fer clic.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opcional",
        "NO_BOT_MESSAGE": "Per generar suggeriments addicionals amb IA, connecta un bot.",
        "BOT_CONNECTED_MESSAGE": "Els suggeriments de preguntes d'IA del bot es poden activar a la seva",
        "BOT_SETTINGS_LINK": "configuració"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Correus electrònics alternatius",
        "SUB_TEXT": "Adreces addicionals que aquesta safata d'entrada ha de tractar com a pròpies en rebre correu reenviat.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Afegeix",
        "REMOVE": "Elimina",
        "EMPTY": "No hi ha cap correu electrònic alternatiu configurat.",
        "HELP_TEXT": "Quan arribi un correu electrònic amb una d'aquestes adreces com a destinatari, les respostes s'enviaran amb la mateixa adreça com a remitent. Assegureu-vos que el vostre servidor SMTP de sortida permet l'enviament des d'aquestes adreces.",
        "SIGNATURE_LABEL": "Signatura",
        "PRIMARY_SIGNATURE": "Principal (per defecte)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Signatures addicionals",
        "SUB_TEXT": "Defineix signatures addicionals aquí i, tot seguit, assigna-les als correus alternatius de sota.",
        "OPTION": "Signatura {number}",
        "ADD": "Afegeix signatura",
        "REMOVE": "Elimina",
        "HELP_TEXT": "Quan s'envia una resposta des d'un correu alternatiu, s'utilitza la signatura assignada en lloc de la de la bústia. Els correus alternatius que es deixen a «Principal (per defecte)» tornen a la signatura de la bústia."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Suprimeix",
      "AVATAR_DELETE_BUTTON_TEXT": "Suprimeix Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Aquesta safata d'entrada està marcada per suprimir-se",
      "RESTORE_BUTTON_TEXT": "Restaura",
      "CONFIRM": {
        "TITLE": "Confirma esborrat",
        "MESSAGE": "N'estas segur? ",
        "PLACE_HOLDER": "Escriu {inboxName} per confirmar",
        "YES": "Si, esborra ",
        "NO": "No, segueix "
      },
      "API": {
        "SUCCESS_MESSAGE": "S'ha suprimit la safata d'entrada correctament",
        "MARKED_FOR_DELETION_MESSAGE": "Safata d'entrada marcada per suprimir-se",
        "RESTORE_SUCCESS_MESSAGE": "Safata d'entrada restaurada correctament",
        "ERROR_MESSAGE": "No s'ha pogut eliminar la safata d'entrada. Torneu-ho a provar més endavant.",
        "RESTORE_ERROR_MESSAGE": "No s'ha pogut restaurar la safata d'entrada. Torna-ho a provar més tard.",
        "AVATAR_SUCCESS_MESSAGE": "L'avatar de la safata d'entrada s'ha suprimit correctament",
        "AVATAR_ERROR_MESSAGE": "No s'ha pogut esborrar l'avatar de la safata d'entrada. Torneu-ho a provar."
      }
    },
    "TABS": {
      "SETTINGS": "Configuracions",
      "COLLABORATORS": "Col·laboradors",
      "AUTOMATIC_PRIORITY": "Prioritat automàtica",
      "AUTOMATIC_LABELING": "Etiquetatge automàtic",
      "CONFIGURATION": "Configuració",
      "CAMPAIGN": "Campanyes",
      "PRE_CHAT_FORM": "Formulari de xat previ",
      "BUSINESS_HOURS": "Horari comercial",
      "WIDGET_BUILDER": "Creador del widget",
      "BOT_CONFIGURATION": "Configuracions del bot",
      "SLA": "SLA"
    },
    "SETTINGS": "Configuracions",
    "FEATURES": {
      "LABEL": "Característiques",
      "DISPLAY_FILE_PICKER": "Mostra el selector de fitxers al widget",
      "DISPLAY_EMOJI_PICKER": "Mostra el selector d'emoji al widget",
      "ALLOW_END_CONVERSATION": "Permet als usuaris finalitzar la conversa des del widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Mostra el botó 'Inicia una conversa nova' a la capçalera del widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Amaga el camp d'entrada quan es mostri el botó d'iniciar una nova conversa",
      "SHOW_HANDOFF_BUTTON": "Mostra el botó 'Transfereix a un operador' a la capçalera del widget",
      "AUTO_CLOSE_OLD": "Marca com a resoltes totes les trucades anteriors del mateix número en resoldre'n una",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Assigna automàticament les trucades perdudes en fer una trucada sortint",
      "USE_INBOX_AVATAR_FOR_BOT": "Utilitza el nom i l'avatar de la safata d'entrada per al bot",
      "ALLOW_OFFLINE_REPLY": "Permet als agents enviar missatges quan el contacte estigui desconnectat i la continuïtat per correu electrònic no estigui disponible"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script del missatger",
      "MESSENGER_SUB_HEAD": "Col·loca aquest botó dins de l'etiqueta body",
      "INBOX_AGENTS": "Agents",
      "INBOX_TEAMS": "Equips",
      "INBOX_COOPERATORS": "Col·laboradors",
      "SELECT_PLACEHOLDER": "Selecciona",
      "AGENTS_OR_TEAMS_INFO": "Pots assignar agents o equips, però no tots dos alhora.",
      "INBOX_AGENTS_SUB_TEXT": "Afegir o eliminar agents d'aquesta safata d'entrada",
      "AGENT_ASSIGNMENT": "Conversació Assignada",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Actualitza la configuració de l'assignació de conversa",
      "UPDATE": "Actualitza",
      "ENABLE_EMAIL_COLLECT_BOX": "Activa la bústia de recollida de correu electrònic",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Activa o desactiva la casella de recollida de correu electrònic en una conversa nova",
      "AUTO_ASSIGNMENT": "Activa l'assignació automàtica",
      "ENABLE_CSAT": "Habilita CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Habilita el CSAT a cada missatge",
      "SENDER_NAME_SECTION": "Activa el nom de l'agent al correu electrònic",
      "ENABLE_CSAT_SUB_TEXT": "Activa/desactiva l'enquesta CSAT (satisfacció del client) després de resoldre una conversa",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Habilita o inhabilita l'enquesta CSAT per a cada missatge enviat pels agents",
      "SENDER_NAME_SECTION_TEXT": "Activa/Desactiva la mostra del nom de l'agent al correu electrònic, si està desactivat, mostrarà el nom de l'empresa",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Activa la continuïtat de la conversa per correu electrònic",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Les converses continuaran per correu electrònic si l'adreça electrònica de contacte està disponible.",
      "RESPOND_FROM_EMAIL": "Respon des del correu electrònic",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Els correus electrònics al client (tant les respostes com les transcripcions de la conversa) s'envien amb la configuració SMTP de la safata d'entrada de correu seleccionada, des de l'adreça seleccionada (l'adreça pròpia de la safata d'entrada o un dels seus àlies), i les respostes del client arriben a través de la seva adreça IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Les transcripcions de la conversa s'envien amb la configuració SMTP de la safata d'entrada de correu seleccionada, des de l'adreça seleccionada (l'adreça pròpia de la safata d'entrada o un dels seus àlies), i les respostes arriben a través de la seva adreça IMAP.",
      "SHOW_WELCOME_SCREEN": "Mostra la pantalla de benvinguda",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Mostra la pantalla de benvinguda quan s'obri el widget. Si està desactivat, el widget anirà directament a la vista de la conversa.",
      "AUTO_CLOSE_PENDING": "Resol automàticament els xats amb IA després de (hores)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Resol automàticament els xats amb IA després de X hores d'inactivitat.",
      "LOCK_TO_SINGLE_CONVERSATION": "Bloqueja a una sola conversa",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Activa o desactiva diverses converses per al mateix contacte en aquesta safata d'entrada",
      "INBOX_UPDATE_TITLE": "Configuració de la safata d'entrada",
      "INBOX_UPDATE_SUB_TEXT": "Actualitza la configuració de la safata d'entrada",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activa o desactiva l'assignació automàtica d'agents disponibles a les noves converses",
      "HMAC_VERIFICATION": "Validació de la Identitat del Usuari",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Rota la clau",
        "TITLE": "Vols rotar la clau secreta?",
        "WARNING": "La clau actual es revoca en el moment que la rotis.",
        "WARNING_DETAIL": "No hi ha cap període de solapament i no es pot restaurar.",
        "IMPACT": "Els teus servidors han de signar els usuaris amb la clau nova. Qui encara estigui signat amb l'antiga no passarà la verificació. Si la validació d'identitat és obligatòria, no podrà iniciar una conversa.",
        "CONFIRM": "Rota la clau",
        "CANCEL": "Cancel·la",
        "SUCCESS": "La clau secreta s'ha rotat correctament",
        "ERROR": "No s'ha pogut rotar la clau secreta, torna-ho a provar"
      },
      "HMAC_LINK_TO_DOCS": "Pots llegir més aquí.",
      "HMAC_MANDATORY_VERIFICATION": "Fer complir la validació de la identitat de l'usuari",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Força una conversa nova en cada càrrega del widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Si s'activa, obrir el widget en una pestanya o finestra nova inicia una conversa nova.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Oblida el contacte quan s'inicia una conversa nova",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Si es desactiva, una conversa nova iniciada des del widget manté el contacte anterior.",
      "INBOX_IDENTIFIER": "Identificador de la safata d'entrada",
      "INBOX_IDENTIFIER_SUB_TEXT": "Utilitza el token \"inbox_identifier\" que es mostra aquí per autenticar els vostres clients de l'API.",
      "FORWARD_EMAIL_TITLE": "Reenvia al correu electrònic",
      "FORWARD_EMAIL_SUB_TEXT": "Comença a reenviar els teus correus electrònics a la següent adreça electrònica.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sincronització de correu",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Habilita la sincronització automàtica i la descàrrega de correus entrants d'aquesta safata d'entrada",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Domini de correu personalitzat",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Habilita-ho per utilitzar un domini de correu personalitzat per als correus sortints",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Pots llegir-ne més aquí.",
      "FACEBOOK_COMMENTS_TITLE": "Comentaris de Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Permet missatges després de resoldre la conversa",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Permet als usuaris finals enviar missatges fins i tot després de resoldre la conversa.",
      "WIDGET_STATUS_LABEL": "Estat del widget",
      "WIDGET_STATUS_ENABLED": "Habilitat",
      "WIDGET_STATUS_BUSINESS_HOURS": "Habilitat durant l'horari laboral",
      "WIDGET_STATUS_DISABLED": "Inhabilitat",
      "WIDGET_STATUS_HELP_TEXT": "Controla quan es mostra el widget als visitants del teu lloc web",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Actualitza la configuració del formulari de xat prèvia",
      "EXPLICIT_CSAT_LOCALE": "Idioma de l'enquesta CSAT i del correu",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Tria l'idioma per a tots els correus als clients, incloent-hi les enquestes CSAT, les transcripcions de converses i les notificacions per correu",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Hereta del compte",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Connexió de WhatsApp",
        "SUBTITLE": "Com està connectada aquesta safata a WhatsApp.",
        "PROVIDER": "Proveïdor",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Connectat mitjançant el registre integrat de Meta",
        "STATUS": "Estat",
        "CONNECTED": "Connectat",
        "RECONNECT_HINT": "Feu clic a Torna a connectar a l’avís de dalt.",
        "PHONE_NUMBER": "Número de telèfon",
        "BUSINESS_ACCOUNT": "ID del compte de WhatsApp Business",
        "OPEN_MANAGER": "Obre a WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID del número de telèfon",
        "TEMPLATES": "Plantilles de missatges",
        "TEMPLATES_COUNT": "{approved} de {total} aprovades",
        "TEMPLATES_SYNCED": "Última sincronització: {date}",
        "TEMPLATES_NOT_SYNCED": "Encara no sincronitzades",
        "MANAGE_TEMPLATES": "Gestiona les plantilles"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centre d'ajuda",
      "PLACEHOLDER": "Selecciona Centre d'ajuda",
      "SELECT_PLACEHOLDER": "Selecciona Centre d'ajuda",
      "REMOVE": "Suprimeix Centre d'ajuda",
      "SUB_TEXT": "Adjunta un Centre d'ajuda amb la safata d'entrada"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Límit d'assignació automàtica",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Introdueix un valor superior a 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limita el nombre màxim de converses d'aquesta safata d'entrada que es poden assignar automàticament a un agent"
    },
    "SLA": {
      "TITLE": "Polítiques d'SLA",
      "SUB_TEXT": "Configura els temps de resposta i resolució de l'SLA per a cada nivell de prioritat de la conversa.",
      "LOADING": "S'estan carregant les polítiques d'SLA...",
      "FIELDS": {
        "ACTIVE": "Actiu",
        "TICKET_PRIORITY": "Prioritat del tiquet",
        "FIRST_RESPONSE_TIME": "Temps de la primera resposta",
        "EVERY_RESPONSE_TIME": "Temps de cada resposta",
        "RESOLUTION_TIME": "Temps de resolució",
        "PLACEHOLDER": "p. ex. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Polítiques d'SLA actualitzades correctament.",
        "ERROR_MESSAGE": "No s'han pogut actualitzar les polítiques d'SLA. Torna-ho a provar."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Prioritat automàtica",
      "SUB_TEXT": "Configura l'assignació automàtica de prioritat segons el contingut de la conversa.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Avís de facturació",
        "MESSAGE": "Cada avaluació de prioritat comportarà un cost. Consulta els detalls del teu pla per obtenir informació sobre els preus."
      },
      "MODE": {
        "OFF": "Desactivat",
        "ALL_MESSAGES": "Activat per a tots els missatges entrants",
        "FIRST_MESSAGE": "Activat només per al primer missatge entrant"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configuració dels nivells de prioritat",
        "SUB_TEXT": "Configura quins nivells de prioritat han d'estar habilitats i les seves descripcions. Proporciona criteris clars perquè la IA determini quan assignar aquesta prioritat."
      },
      "DESCRIPTION_LABEL": "Descripció",
      "DESCRIPTION_PLACEHOLDER": "Descriu les converses que s'han de marcar amb la prioritat {priority}",
      "SET_AS_DEFAULT": "Estableix com a prioritat predeterminada",
      "MULTIPLE_DEFAULTS_WARNING": "Només un nivell de prioritat pot ser el predeterminat. Desmarca els altres predeterminats."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Etiquetatge automàtic",
      "SUB_TEXT": "Configura l'assignació automàtica d'etiquetes segons el contingut de la conversa.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Avís de facturació",
        "MESSAGE": "Cada avaluació d'etiquetatge comportarà un cost. Consulta els detalls del teu pla per obtenir informació sobre els preus."
      },
      "MODE": {
        "OFF": "Desactivat",
        "CONVERSATION_OPEN": "En obrir la conversa",
        "CONVERSATION_CLOSE": "En tancar la conversa",
        "ALL_MESSAGES": "A cada missatge, independentment de l'estat",
        "FIRST_MESSAGE": "Al primer missatge, independentment de l'estat"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Configuració d'etiquetes",
        "SUB_TEXT": "Configura quines etiquetes han d'estar disponibles per a l'assignació automàtica i les seves descripcions. Proporciona criteris clars perquè la IA determini quan aplicar aquesta etiqueta."
      },
      "DESCRIPTION_LABEL": "Descripció",
      "DESCRIPTION_PLACEHOLDER": "Descriu les converses que s'han d'etiquetar com a {label}. Si ho deixes buit, s'utilitzarà la descripció de l'etiqueta.",
      "NO_LABELS_MESSAGE": "No s'ha trobat cap etiqueta. Crea etiquetes primer per habilitar l'etiquetatge automàtic.",
      "CREATE_LABELS_LINK": "Crea etiquetes"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautoritza",
      "SUBTITLE": "La teva connexió a Facebook ha caducat, torna a connectar la vostra pàgina de Facebook per continuar els serveis",
      "MESSAGE_SUCCESS": "La reconnexió s'ha realitzat correctament",
      "MESSAGE_ERROR": "S'ha produït un error; tornau-ho a provar"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Els formularis previs al xat et permeten capturar informació de l'usuari abans que comencin a conversar amb vosaltres.",
      "SET_FIELDS": "Camps del formulari previ al xat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Camps",
        "LABEL": "Etiqueta",
        "PLACE_HOLDER": "Espai reservat",
        "KEY": "Clau",
        "TYPE": "Tipus",
        "REQUIRED": "Necessari"
      },
      "ENABLE": {
        "LABEL": "Activa el formulari de xat previ",
        "OPTIONS": {
          "ENABLED": "Si",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Missatge previ al xat",
        "PLACEHOLDER": "Aquest missatge seria visible per als usuaris juntament amb el formulari"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Els visitants han de proporcionar el seu nom i adreça de correu electrònic abans d'iniciar el xat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Estableix la vostra disponibilitat",
      "SUBTITLE": "Estableix la teva disponibilitat al widget del xat en directe",
      "WEEKLY_TITLE": "Estableix el teu horari setmanal",
      "TIMEZONE_LABEL": "Selecciona la zona horària",
      "UPDATE": "Actualitza la configuració de l'horari comercial",
      "TOGGLE_AVAILABILITY": "Habilita la disponibilitat comercial per a aquesta safata d'entrada",
      "UNAVAILABLE_MESSAGE_LABEL": "Missatge no disponible per als visitants",
      "TOGGLE_HELP": "Si activeu la disponibilitat comercial, es mostraran les hores disponibles al giny del xat en directe, encara que tots els agents estiguin fora de línia. Fora de l'horari disponible, els visitants poden ser avisats amb un missatge i un formulari de xat previ.",
      "DAY": {
        "ENABLE": "Activa la disponibilitat per a aquest dia",
        "UNAVAILABLE": "No disponible",
        "HOURS": "hores",
        "VALIDATION_ERROR": "L'hora d'inici ha de ser abans de l'hora de tancament.",
        "CHOOSE": "Tria"
      },
      "ALL_DAY": "Tot el dia",
      "SAVE_TO_ALL": "Desa a totes les safates d'entrada",
      "SAVE_TO_ALL_TITLE": "Copia l'horari laboral",
      "SAVE_TO_ALL_CONFIRM": "La configuració d'aquest formulari (l'interruptor de disponibilitat, el missatge fora d'oficina, la zona horària i l'horari laboral) es copiarà a totes les altres safates d'entrada, excepte les de correu electrònic i telèfon. Estàs segur que vols continuar?",
      "SAVE_TO_ALL_CANCEL": "Cancel·la",
      "SAVE_TO_ALL_YES": "Sí, copia-ho a totes",
      "SAVE_TO_ALL_SUCCESS": "Horari laboral copiat correctament a totes les altres safates d'entrada",
      "SAVE_TO_ALL_ERROR": "Error en copiar l'horari laboral a altres safates d'entrada"
    },
    "PHONE": {
      "TITLE": "Configuració del telèfon",
      "SUBTITLE": "Configura quines trucades es mostraran en aquesta safata d'entrada.",
      "UPDATE": "Desa la configuració",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configuració del telèfon actualitzada"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Números de telèfon",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Configura els detalls de l'IMAP",
      "NOTE_TEXT": "Per habilitar SMTP, configura IMAP.",
      "UPDATE": "Actualitza la configuració IMAP",
      "TOGGLE_AVAILABILITY": "Activa la configuració IMAP per a aquesta safata d'entrada",
      "TOGGLE_HELP": "Habilitar IMAP ajudarà l'usuari a rebre correu electrònic",
      "EDIT": {
        "SUCCESS_MESSAGE": "La configuració IMAP s'ha actualitzat correctament",
        "ERROR_MESSAGE": "No es pot actualitzar la configuració IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adreça",
        "PLACE_HOLDER": "Adreça (p. ex.: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Inicia la sessió",
        "PLACE_HOLDER": "Inicia la sessió"
      },
      "PASSWORD": {
        "LABEL": "Contrasenya",
        "PLACE_HOLDER": "Contrasenya"
      },
      "ENABLE_SSL": "Habilita SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Torna a autoritzar el teu compte de MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Configura els detalls del SMTP",
      "UPDATE": "Actualitza la configuració SMTP",
      "TOGGLE_AVAILABILITY": "Activa la configuració SNMP per a aquesta safata d'entrada",
      "TOGGLE_HELP": "Habilitar SMTP ajudarà l'usuari a enviar correu electrònic",
      "EDIT": {
        "SUCCESS_MESSAGE": "La configuració SMTP s'ha actualitzat correctament",
        "ERROR_MESSAGE": "No es pot actualitzar la configuració SMTP"
      },
      "ADDRESS": {
        "LABEL": "Adreça",
        "PLACE_HOLDER": "Adreça (p. ex.: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Inicia la sessió",
        "PLACE_HOLDER": "Inicia la sessió"
      },
      "PASSWORD": {
        "LABEL": "Contrasenya",
        "PLACE_HOLDER": "Contrasenya"
      },
      "DOMAIN": {
        "LABEL": "Domini",
        "PLACE_HOLDER": "Domini"
      },
      "ENCRYPTION": "Xifratge",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Obre el mode de verificació SSL",
      "AUTH_MECHANISM": "Autenticació"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Lliurament del correu (DNS)",
      "SUB_TITLE": "Cada dia laborable revisem els registres SPF, DKIM, DMARC i MX de {domain}. Quan alguna cosa fa que els servidors receptors rebutgin o enviïn a correu brossa les vostres respostes, els administradors reben un correu amb la solució.",
      "RUN": "Executa la revisió",
      "RUN_SUCCESS": "La revisió de DNS ha acabat",
      "RUN_ERROR": "No s'ha pogut executar la revisió de DNS, torneu-ho a provar",
      "NOT_CHECKED": "Encara no s'ha revisat.",
      "CHECKED_AT": "Última revisió: {time}.",
      "DNS_UNAVAILABLE": "L'última revisió no ha obtingut resposta dels servidors de noms del domini. El resultat següent és de la revisió anterior.",
      "SENDER": {
        "SMTP": "Les respostes s'envien mitjançant {host}.",
        "PLATFORM": "Les respostes s'envien mitjançant els nostres servidors de correu."
      },
      "STATUS": {
        "OK": "Tots els registres estan en ordre",
        "WARNING": "Alguns registres es podrien millorar",
        "ERROR": "Les respostes potser no arriben als destinataris",
        "UNKNOWN": "Desconegut"
      },
      "SEVERITY": {
        "ERROR": "Problema",
        "WARNING": "Advertència"
      },
      "FIX": "Solucioneu-ho amb aquest registre DNS:",
      "RECORD_TYPE": "Tipus",
      "RECORD_HOST": "Nom",
      "RECORD_VALUE": "Valor",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Falta el registre SPF",
          "DESCRIPTION": "El domini no indica quins servidors poden enviar-ne el correu. Molts servidors de correu consideren llavors les vostres respostes correu brossa. Afegiu un registre SPF que permeti {sender}."
        },
        "spf_multiple": {
          "TITLE": "El domini té {count} registres SPF",
          "DESCRIPTION": "Un domini només pot tenir un registre SPF. Si en té més, els servidors receptors ignoren l'SPF i sovint rebutgen el correu. Combineu-los en un sol registre."
        },
        "spf_not_authorized": {
          "TITLE": "L'SPF no permet el servidor que envia les vostres respostes",
          "DESCRIPTION": "Les vostres respostes s'envien mitjançant {sender}, però el registre SPF del domini no el menciona. Registre actual: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "El registre SPF necessita massa consultes DNS",
          "DESCRIPTION": "Els servidors receptors deixen de comprovar l'SPF després de {limit} consultes DNS, però {sender}, que envia les vostres respostes, només s'assoleix després de {lookups}. Les vostres respostes no superen l'SPF. Moveu {sender} a l'inici del registre i elimineu els include que el domini ja no utilitza."
        },
        "spf_lookups_others": {
          "TITLE": "Alguns remitents del registre SPF superen el límit de consultes",
          "DESCRIPTION": "El registre SPF necessita {lookups} consultes DNS i els servidors receptors s'aturen després de {limit}. Les vostres respostes es validen a temps i superen la comprovació, però el correu d'aquests remitents no supera l'SPF: {senders}. Elimineu els include que el domini ja no utilitza."
        },
        "spf_malformed": {
          "TITLE": "El registre SPF està malmès",
          "DESCRIPTION": "Els servidors receptors no poden llegir el registre SPF del domini, de manera que no protegeix les vostres respostes. El problema és a: {terms}. Substituïu el registre pel corregit."
        },
        "dkim_missing": {
          "TITLE": "La signatura DKIM no està configurada",
          "DESCRIPTION": "No hem trobat cap clau DKIM a {selectors}. Sense ella, les vostres respostes no estan signades i és més probable que acabin com a correu brossa. Activeu la signatura DKIM del domini amb el vostre proveïdor de correu."
        },
        "dmarc_missing": {
          "TITLE": "Falta el registre DMARC",
          "DESCRIPTION": "Els grans proveïdors de correu, com Gmail i Microsoft, esperen un registre DMARC. Sense ell, és més probable que les vostres respostes acabin com a correu brossa."
        },
        "dmarc_fails": {
          "TITLE": "El DMARC indica als receptors que rebutgin les vostres respostes",
          "DESCRIPTION": "La política DMARC del domini és «{policy}» i les vostres respostes no superen ni l'SPF ni el DKIM, de manera que els receptors les rebutgen o les envien a correu brossa. Solucioneu primer l'SPF i el DKIM indicats més amunt."
        },
        "dmarc_blocks_platform": {
          "TITLE": "El DMARC bloqueja les respostes enviades mitjançant els nostres servidors de correu",
          "DESCRIPTION": "Aquesta safata envia les respostes mitjançant els nostres servidors de correu, però la política DMARC del domini és «{policy}», de manera que els receptors les rebutgen o les envien a correu brossa. Configureu l'SMTP del vostre propi servidor de correu per a aquesta safata."
        },
        "mx_missing": {
          "TITLE": "El domini no té cap registre MX",
          "DESCRIPTION": "Sense un registre MX ningú pot enviar correu al domini, de manera que els clients no us poden respondre."
        }
      }
    },
    "NOTE": "Nota: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar del lloc web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar esborrat correctament",
              "ERROR_MESSAGE": "S'ha produït un error; tornau-ho a provar"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nom del lloc web",
          "PLACE_HOLDER": "Introdueix el nom del vostre lloc web (per exemple: Acme Inc)",
          "ERROR": "Introdueix un nom de lloc web vàlid"
        },
        "WELCOME_HEADING": {
          "LABEL": "Encapçalament de benvinguda",
          "PLACE_HOLDER": "Hola!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Lema de benvinguda",
          "PLACE_HOLDER": "Facilitem la connexió amb nosaltres. Pregunteu-nos qualsevol cosa o compartiu els vostres comentaris."
        },
        "REPLY_TIME": {
          "LABEL": "Temps de resposta",
          "IN_A_FEW_MINUTES": "En pocs minuts",
          "IN_A_FEW_HOURS": "En poques hores",
          "IN_A_DAY": "En un dia"
        },
        "WIDGET_COLOR_LABEL": "Color del Widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Posició de la bombolla del widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Alçada màxima dels missatges no llegits (px)",
          "PLACE_HOLDER": "Sense límit",
          "HELP_TEXT": "Limita l'alçada màxima de la finestra de missatges no llegits en píxels. Deixa-ho buit per al comportament predeterminat (sense límit)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Tipus de bombolla de widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Xateja amb nosaltres",
          "LABEL": "Títol del llançador de bombolles de widget",
          "PLACE_HOLDER": "Xateja amb nosaltres"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Actualitza la configuració del widget",
          "API": {
            "SUCCESS_MESSAGE": "La configuració del widget s'ha actualitzat correctament",
            "ERROR_MESSAGE": "No es pot actualitzar la configuració del widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Vista prèvia",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Esquerra",
          "RIGHT": "Dreta"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Estàndard",
          "EXPANDED_BUBBLE": "Bombolla expandida"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Per defecte",
        "CHAT": "Xat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Normalment responem en pocs minuts",
        "IN_A_FEW_HOURS": "Normalment responem en poques hores",
        "IN_A_DAY": "Normalment respon en un dia"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Inicia la conversa",
        "CHAT_INPUT_PLACEHOLDER": "Escriu el missatge"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Estem en línia",
          "OFFLINE": "Estem fora en aquest moment"
        },
        "USER_MESSAGE": "Hola",
        "AGENT_MESSAGE": "Hola"
      },
      "BRANDING_TEXT": "Desenvolupat per JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Altres proveïdors"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Lloc web",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Correu electrònic",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal de l'API",
      "PHONE": "Telèfon SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
